import axios from "axios";
import api from "./api";
import { message } from "antd";

const handleError = (error) => {
  const message =
    error.response?.data?.DisplayMessage ||
    error.response?.data?.Message ||
    error.message ||
    "Something went wrong";
  throw new Error(message);
};

export const getItemNearToExpiryDiscountApi = async () => {
  try {
    const response = await api.get(`/ItemNearToExpiryDiscount`);
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
export const getItemNearToExpiryDiscountApibydivision = async (payload) => {
  try {
    const { divisionCode, departmentCode } = payload;
    const response = await api.get(
      `/ItemNearToExpiryDiscount/GetByDivision/${divisionCode}`,
      {
        params: {
          departmentCode,
        },
      },
    );
    if (response?.data?.IsSuccess === true && response?.data?.Data === null) {
      message.error(response?.data?.DisplayMessage || "Failed to fetch data");
    } else {
      message.success(
        response?.data?.DisplayMessage || "Data fetched successfully",
      );
    }

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};
export const postItemNearToExpiryDiscountApi = async (payload) => {
  try {
    const response = await api.post(`/ItemNearToExpiryDiscount`, {
      ...payload,
    });
    message.success("Records created successfully.");
    return response?.data || [];
  } catch (error) {
    message.error("Failed to Create Record");
    handleError(error);
    return [];
  }
};
export const getNearToExpiryDiscountByIdApi = async (id) => {
  try {
    const response = await api.get(`/ItemNearToExpiryDiscount/${id}`);
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
export const putNearToExpiryDiscountApi = async (id, payload) => {
  try {
    const response = await api.put(`/ItemNearToExpiryDiscount/${id}`, {
      ...payload,
    });
    message.success("Record Updated successfully.");
    return response?.data || [];
  } catch (error) {
    handleError(error);
    message.error("Failed to update Record");
    return [];
  }
};
export const deleteNearToExpiryDiscountApi = async (id) => {
  try {
    const response = await api.delete(`/ItemNearToExpiryDiscount/${id}`);
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};

export const getAllListApi = async (location, division, date) => {
  try {
    const response = await api.get(
      `/NeartoExpiry/neartoexpiryalllist/${location}/${division}/${date}`,
    );
    if (response?.data?.IsSuccess === true && response?.data?.Data === null) {
      message.error(response?.data?.DisplayMessage || "Failed to fetch data");
    } else {
      message.success(
        response?.data?.DisplayMessage || "Data fetched successfully",
      );
    }
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
export const getScanApi = async (payload) => {
  try {
    const { location, date, searchBy, searchValue } = payload;
    const response = await api.get(
      `/NeartoExpiry/neartoexpiryscan/${location}/${date}/${searchBy}/${searchValue}`,
    );
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
export const getScanSaveApi = async (payload) => {
  try {
    const response = await api.post(`/NeartoExpiry/neartoexpirysave`, payload);
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
export const getListForApproveApi = async (payload) => {
  try {
    const { loaction, division, date } = payload;
    const response = await api.get(
      `/NeartoExpiry/NearToExpiryListforApprove/${loaction}/${division}/${date}`,
    );
    if (response?.data?.IsSuccess === true && response?.data?.Data === null) {
      message.error(response?.data?.DisplayMessage || "Failed to fetch data");
    } else {
      message.success(
        response?.data?.DisplayMessage || "Data fetched successfully",
      );
    }
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
export const getListAfterApproveApi = async (payload) => {
  try {
    const { location, division, date } = payload;
    const response = await api.get(
      `/NeartoExpiry/NearToExpiryListAfterApproved/${location}/${division}/${date}`,
    );
    if (response?.data?.IsSuccess === true && response?.data?.Data === null) {
      message.error(response?.data?.DisplayMessage || "Failed to fetch data");
    } else {
      message.success(
        response?.data?.DisplayMessage || "Data fetched successfully",
      );
    }
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
export const expiryApproveApi = async (payload) => {
  try {
    const response = await api.post(
      `/NeartoExpiry/neartoexpiryapprove`,
      payload,
    );
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
